import { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// RasPm Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// RasPm Dashboard examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// NewUser page components
import AddForm from "../components/AddForm";

import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { RequestService } from "services/RequestService";
import MDSnackbar from "components/MDSnackbar";
import { useNavigate } from "react-router-dom";

const validatePassword = (password) => {
  const errors = [];

  if (password.length < 6) {
    errors.push("يجب أن تحتوي كلمة المرور على 6 أحرف على الأقل");
  }
  if (!/[A-Z]/.test(password)) {
    errors.push("يجب أن تحتوي كلمة المرور على حرف كبير واحد على الأقل");
  }
  if (!/[a-z]/.test(password)) {
    errors.push("يجب أن تحتوي كلمة المرور على حرف صغير واحد على الأقل");
  }
  if (!/[0-9]/.test(password)) {
    errors.push("يجب أن تحتوي كلمة المرور على رقم واحد على الأقل");
  }
  if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
    errors.push("يجب أن تحتوي كلمة المرور على رمز خاص واحد على الأقل");
  }

  return errors;
};

function NewUser() {
  const [show, setShow] = useState(false);
  const [error, setError] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    displayName: "",
    email: "",
    password: "",
    confirmPassword: "",
    userType: "",
    companyId: "",
  });
  const [passwordMatchError, setPasswordMatchError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Reset password match error
    setPasswordMatchError("");

    const passwordErrors = validatePassword(formData.password);
    if (passwordErrors.length > 0) {
      setMessage(passwordErrors.join("\\n"));
      setError(true);
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setPasswordMatchError("كلمة المرور غير متطابقة");
      return;
    }
    if (formData.companyId === null) {
      delete formData.companyId;
    }
    try {
      const { confirmPassword, ...submitData } = formData;
      // Remove companyId if it's empty string
      if (submitData.companyId === "") {
        delete submitData.companyId;
      }
      const response = await RequestService.post("Auth/register", submitData);
      if (response.data.error === false) {
        setMessage(response.data.message);
        setShow(true);
        setTimeout(() => {
          navigate("/pages/users/view");
        }, 1500);
      } else {
        setMessage(response.data.message);
        setError(true);
      }
    } catch (error) {
      setMessage(error.response?.data?.message || "حدث خطأ أثناء إضافة المستخدم");
      setError(true);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3} mb={20} height="65vh">
        <Grid container justifyContent="center" alignItems="center" sx={{ height: "100%", mt: 8 }}>
          <Grid item xs={12} lg={8}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  إضافة مستخدم جديد
                </MDTypography>
              </MDBox>
              <MDBox p={3}>
                <AddForm
                  formData={formData}
                  handleChange={handleChange}
                  handleSubmit={handleSubmit}
                  validatePassword={validatePassword}
                  passwordMatchError={passwordMatchError}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
      <MDSnackbar
        color="success"
        icon="check"
        title="تمت العملية بنجاح"
        content={message}
        open={show}
        autoHideDuration={3000}
        onClose={() => setShow(false)}
        close={() => setShow(false)}
        bgWhite
      />
      <MDSnackbar
        color="error"
        icon="warning"
        title="فشلت العملية"
        content={message.split("\\n").map((line, i) => (
          <div key={i}>{line}</div>
        ))}
        open={error}
        autoHideDuration={3000}
        onClose={() => setError(false)}
        close={() => setError(false)}
        bgWhite
      />
    </DashboardLayout>
  );
}

export default NewUser;